<app-create-ticket *ngIf="checkCaseModalInHome" (checkIsCaseModalOpenInHome)= "checkIsCaseModalOpen($event)"></app-create-ticket>
<div class="help-block" *ngIf="footer?.footerText?.length > 0 ">
  <div id="tierone">
    <div class="container">
      <div class="row footerrow">
        <div class="col-md-12 help-header">
          <h3>{{this.footerContent?.needHelpTitle}}</h3>
          <p>{{this.footerContent?.needHelpContent}}</p>
        </div>
        <div class="col-md-12 ">
          <div class="row help-block">
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.callNumberContent">
              <a href="tel:{{this.footerContent?.callNumber}}" [class.disabled]="this.footerContent?.callNumber === '' || this.footerContent?.callNumber === null">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.callNumberIcon}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.callNumberContent}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.callNumberContent2">
              <a href="tel:{{this.footerContent?.callNumber2}}" [class.disabled]="this.footerContent?.callNumber2 === '' || this.footerContent?.callNumber2 === null">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.callNumberIcon2}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.callNumberContent2}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.callNumberContent3">
              <a href="tel:{{this.footerContent?.callNumber3}}" [class.disabled]="this.footerContent?.callNumber3 === '' || this.footerContent?.callNumber3 === null">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.callNumberIcon3}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.callNumberContent3}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.callNumberContent4">
              <a href="tel:{{this.footerContent?.callNumber4}}" [class.disabled]="this.footerContent?.callNumber4 === '' || this.footerContent?.callNumber4 === null">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.callNumberIcon4}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.callNumberContent4}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.callNumberContent5">
              <a href="tel:{{this.footerContent?.callNumber5}}" [class.disabled]="this.footerContent?.callNumber5 === '' || this.footerContent?.callNumber5 === null">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.callNumberIcon5}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.callNumberContent5}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.chatContent && disableLiveChatSHP == false">
              <a (click)="openChat('chat')" >
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.chatIcon}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.chatContent}}</h4>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 contact-links" *ngIf="this.footerContent.chatContent && disableLiveChatSHP == true">
              <a id="chatfixLink">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.chatIcon}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.chatContent}}</h4>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-md-12 contact-links" *ngIf="this.footerContent.createCase">
              <a (click)="handleNavigate('case')">
                <div class="row">
                  <div class="col-2">
                    <i class="{{this.footerContent?.createCaseIcon}} icon"></i></div>
                  <div class="col-10">
                    <h4 class="help-text">{{this.footerContent?.createCase}}</h4>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-md-12 contact-links" *ngIf="this.footerContent.additionalInfo">
                <div class="row">
                  <div class="col-12">
                    <h4 class="help-text" [innerHTML]="this.footerContent.additionalInfo"></h4>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="page-footer font-small blue pt-4">

  <!-- Footer Links -->
  <div class="container text-center text-md-left">


    <!-- Grid row -->
    <div class="row">

      <!-- Grid column -->
      <div class="col-md-6 mt-md-0 mt-3 articles-block" *ngIf="topArticle.total > 0">

        <!-- Content -->
        <p class="text-uppercase footer-headings">Top Articles</p>
        <ul class="list-unstyled">
          <li class="list-style top-article-block" *ngFor="let article of topArticle.items; let i= index">
          <a (click)="handleNavigation(article)">{{article.article_title}}</a>
          </li>
        </ul>

       

      </div>
      <!-- Grid column -->

      <hr class="clearfix w-100 d-md-none pb-3" *ngIf="footer?.helpfulLinks?.enable && footer?.helpfulLinks?.links.length > 0">

      <!-- Grid column -->
      <div class="col-md-3 mb-md-0 mb-3" *ngIf="footer?.helpfulLinks?.enable && footer?.helpfulLinks?.links.length > 0">

        <!-- Links -->
        <p class="footer-headings">{{footer?.helpfulLinks?.sectionTitle}}</p>

        <ul class="list-unstyled">
          <li class="list-style" *ngFor="let link of footer?.helpfulLinks?.links">
            <a href={{link.linkURL}} [class.disabled]="link.linkURL === '' || link.linkURL === null" [attr.target]="link.openLinkInNewWindow?'_blank':'_self'">{{link.linkText}}</a>
          </li>
        </ul>

      </div>

      <hr class="clearfix w-100 d-md-none pb-3" *ngIf="footer?.connectionLinks?.enable && footer?.connectionLinks?.links.length >0 ">
      <!-- Grid column -->

      <!-- Grid column -->
      <div class="col-md-3 mb-md-0 mb-3" *ngIf="footer?.connectionLinks?.enable && footer?.connectionLinks?.links.length >0 ">

        <!-- Links -->
        <p class="footer-headings">{{footer?.connectionLinks?.sectionTitle}}</p>

        <ul class="list-unstyled">
          <li class="list-style" *ngFor="let connectionLink of footer?.connectionLinks?.links">
            <a href={{connectionLink.linkURL}} [class.disabled]="connectionLink.linkURL === '' || connectionLink.linkURL === null"
              [attr.target]="connectionLink.openLinkInNewWindow?'_blank':'_self'">{{connectionLink.linkText}}</a>
          </li>
          </ul>

      </div>
      <hr class="clearfix w-100 d-md-none pb-3" *ngIf="footer?.connectionLinks?.enable && footer?.connectionLinks?.mediaLinks.length>0">
      <!-- Grid column -->
      <div class="col-md-3 mb-md-0 mb-3" *ngIf="footer?.connectionLinks?.enable && footer?.connectionLinks?.mediaLinks.length>0">   
        <!-- Links -->
        <p class="footer-headings">{{mediaTitle}}</p>
           <!-- MEDIA LINKS-->
           <!-- <ul class="list-unstyled"  *ngIf="footer?.connectionLinks?.horizontal">
            <li class="list-style" *ngFor="let link of footer?.connectionLinks?.mediaLinks">
              <a href={{link.linkURL}} [class.disabled]="link.linkURL === '' || link.linkURL === null" [attr.target]="link.openLinkInNewWindow?'_blank':'_self'">
                <i class="{{link.type}}" style="font-size:24px; margin:5px;"></i>
              </a>
            </li>
          </ul> -->
          <!-- <ul class="list-unstyled"  *ngIf="footer?.connectionLinks?.horizontal"> -->
           <div class="horizontal-icons" *ngIf="footer?.connectionLinks?.horizontal">
            <span class="list-style" *ngFor="let link of footer?.connectionLinks?.mediaLinks">
              <a href={{link.linkURL}} [class.disabled]="link.linkURL === '' || link.linkURL === null" [attr.target]="link.openLinkInNewWindow?'_blank':'_self'">
                <i class="{{link.type}}" style="font-size:24px; margin-right:10px;"></i>
              </a>
            </span>
          </div>
          <!-- </ul> -->
          <ul class="list-unstyled" *ngIf="!footer?.connectionLinks?.horizontal">
              <li class="list-style" *ngFor="let link of footer?.connectionLinks?.mediaLinks">
                <a href={{link.linkURL}} [class.disabled]="link.linkURL === '' || link.linkURL === null" [attr.target]="link.openLinkInNewWindow?'_blank':'_self'">
                  <i class="{{link.type}}" style="font-size:24px; margin-right:15px;"></i>
                  <!-- <span>{{link.linkText}}</span> -->
                </a>
              </li>
          </ul>

      </div>
      <!-- Grid column -->

    </div>
    <!-- Grid row -->

  </div>
  <!-- Footer Links -->

  <!-- Copyright -->

  <div class="footer-copyright py-3">
    <div class="container"><span class="footer-image-link"><a href="{{img.linkURL}}" [class.disabled]="img.linkURL === '' || img.linkURL === null"
          [attr.target]="img.openLinkInNewWindow?'_blank':'_self'" *ngFor="let img of footer?.logos"><img
            [src]="getImage(img)" *ngIf="getImage(img)" class="footer-image" height="65px" alt={{img.imageAltText}}></a></span>
      <div class="copyright" [innerHTML]="copyright"></div>
    </div>
  </div>

</footer>